import type { CoverageLookups } from './coverageReport'

// Profiles are readable only by their own account and administrators, so a
// supervisor is named by the teams they supervise.
export function supervisorLabel(supervisorId: string, lookups: Pick<CoverageLookups, 'teams' | 'supervisors'>): string {
  const teams = Array.from(lookups.supervisors)
    .filter(([, id]) => id === supervisorId)
    .map(([teamId]) => lookups.teams.get(teamId) ?? 'Unknown team')
    .sort()
  return `Supervisor of ${teams.join(', ')}`
}
